import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { getLatestArticles } from '@/mocks/articles';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';

export default function Home() {
  const latestArticles = getLatestArticles(6);
  const featuredArticles = getLatestArticles(4);

  const jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: '庭院花园',
        url: 'https://tingyuanhuayuan.cn/',
        description: '专注庭院花园设计与草坪造景，提供从草坪选种、养护技巧到景观搭配的专业花园绿化解决方案。',
        contactPoint: { '@type': 'ContactPoint', telephone: '400-888-9999', contactType: 'customer service' },
        address: { '@type': 'PostalAddress', streetAddress: '园林路168号', addressLocality: '上海', addressRegion: '浦东新区', addressCountry: 'CN' },
      },
      { '@type': 'WebSite', name: '庭院花园', url: 'https://tingyuanhuayuan.cn/', potentialAction: { '@type': 'SearchAction', target: 'https://tingyuanhuayuan.cn/search?q={search_term_string}', 'query-input': 'required name=search_term_string' } },
      { '@type': 'WebPage', name: '首页 - 庭院花园设计 | 草坪造景与庭院绿化专业指南', url: 'https://tingyuanhuayuan.cn/', isPartOf: { '@type': 'WebSite', name: '庭院花园' } },
      {
        '@type': 'FAQPage',
        mainEntity: [
          { '@type': 'Question', name: '如何选择适合自家庭院的草坪品种？', acceptedAnswer: { '@type': 'Answer', text: '选择草坪品种需要综合考虑气候、光照、土壤和使用需求。冷季型草适合北方地区，暖季型草适合南方地区；阳光充足的庭院可选喜光品种，遮阴多的庭院则需耐阴品种。' } },
          { '@type': 'Question', name: '草坪需要多久修剪一次？', acceptedAnswer: { '@type': 'Answer', text: '生长旺季（春、秋）建议每周修剪一次，夏季和冬季可适当减少频率。遵循三分之一原则，每次修剪量不超过草高的三分之一，保持修剪高度在5-7厘米。' } },
          { '@type': 'Question', name: '庭院花园设计的预算大概是多少？', acceptedAnswer: { '@type': 'Answer', text: '庭院花园设计的预算根据面积、风格和材料差异较大。小型庭院基础设计加草坪铺设约5000-20000元，中等庭院整体景观设计约20000-80000元，大型豪华庭院根据需求定制。' } },
          { '@type': 'Question', name: '如何在阳台铺设草坪？', acceptedAnswer: { '@type': 'Answer', text: '城市阳台铺设草坪推荐使用人造草坪，施工简单且无需养护。如需种植真草坪，需确保阳台光照充足，使用深度至少15厘米的种植槽，选择耐阴矮生品种并注意排水。' } },
        ],
      },
    ],
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
      <Navbar />

      <main>
        <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
          <img src="https://readdy.ai/api/search-image?query=A%20stunning%20courtyard%20garden%20with%20lush%20emerald%20green%20lawn%2C%20surrounded%20by%20elegant%20flowering%20plants%20and%20ornamental%20shrubs%2C%20a%20classical%20white%20marble%20statue%20of%20a%20woman%20as%20focal%20point%2C%20stone%20pathway%20winding%20through%2C%20soft%20golden%20afternoon%20sunlight%2C%20romantic%20garden%20atmosphere%2C%20professional%20landscape%20photography%2C%20lush%20natural%20greenery%2C%20peaceful%20serene%20vibe&width=1600&height=900&seq=hero-main-2026&orientation=landscape" alt="美女被草坪围绕的庭院花园设计" title="美女被草坪围绕的花园设计方案 | 庭院绿化景观设计" className="absolute inset-0 w-full h-full object-cover object-top" />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>
          <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4">
            <span className="inline-block px-4 py-1.5 rounded-full bg-white/20 backdrop-blur-sm text-white text-sm mb-4 border border-white/10">庭院花园设计 · 草坪造景专家</span>
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white text-center leading-tight max-w-4xl">美女被草坪围绕的花园设计方案</h1>
            <p className="mt-4 md:mt-6 text-base md:text-lg text-white/80 text-center max-w-2xl leading-relaxed">探索美女被草坪环绕的庭院花园设计灵感，打造绿意盎然的户外空间。从草坪选种、养护技巧到景观搭配，为您提供专业的花园绿化解决方案，让您的庭院美不胜收。</p>
            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <Link to="/category/huayuan-sheji" className="px-8 py-3 rounded-full bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">探索花园设计</Link>
              <Link to="/about" className="px-8 py-3 rounded-full bg-white/15 backdrop-blur-sm text-white font-medium text-sm hover:bg-white/25 transition-colors border border-white/20 whitespace-nowrap cursor-pointer">了解更多</Link>
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-50">
          <div className="max-w-[1280px] mx-auto">
            <div className="text-center mb-10">
              <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">探索分类</span>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">花园设计知识库</h2>
              <p className="mt-2 text-foreground-500 text-sm max-w-xl mx-auto">从草坪选种到景观搭配，全方位覆盖庭院花园设计的各个领域</p>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
              {categories.map((cat) => (
                <Link key={cat.slug} to={`/category/${cat.slug}`} className="group flex flex-col items-center p-4 md:p-5 rounded-xl bg-background-100 hover:bg-primary-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer">
                  <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 group-hover:bg-primary-100 group-hover:text-primary-600 transition-colors mb-3">
                    <i className={`${cat.icon} text-xl md:text-2xl`}></i>
                  </div>
                  <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-700 whitespace-nowrap">{cat.name}</span>
                  <span className="text-xs text-foreground-400 mt-1">{cat.articles.length}篇文章</span>
                </Link>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
          <div className="max-w-[1280px] mx-auto">
            <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 gap-4">
              <div>
                <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">精选内容</span>
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">花园设计精选文章</h2>
                <p className="mt-2 text-foreground-500 text-sm">精心挑选的庭院设计与草坪造景专业内容</p>
              </div>
              <Link to="/category/huayuan-sheji" className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer">查看全部 <i className="ri-arrow-right-line text-xs"></i></Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
              {featuredArticles.map((article) => (
                <Link key={article.id} to={`/article/${article.id}`} className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer">
                  <div className="relative w-full h-48 md:h-52 overflow-hidden">
                    <img src={article.heroImageUrl} alt={article.title} title={article.title} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" loading="lazy" />
                  </div>
                  <div className="p-4 md:p-5">
                    <div className="flex items-center gap-2 mb-2">
                      <span className="text-xs text-accent-600 bg-accent-100 px-2 py-0.5 rounded-full font-medium">{categories.find((c) => c.slug === article.category)?.name || article.category}</span>
                      <span className="text-xs text-foreground-400">{article.readTime}</span>
                    </div>
                    <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2">{article.title}</h3>
                    <p className="mt-2 text-xs md:text-sm text-foreground-500 line-clamp-2 leading-relaxed">{article.excerpt}</p>
                    <div className="mt-3 flex items-center gap-2 text-xs text-foreground-400">
                      <span>{article.author}</span><span>·</span><span>{article.date}</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-50">
          <div className="max-w-[1280px] mx-auto">
            <div className="mb-10">
              <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">最新发布</span>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">最新文章</h2>
              <p className="mt-2 text-foreground-500 text-sm">持续更新庭院设计与草坪养护的专业知识</p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
              {latestArticles.map((article) => (
                <Link key={article.id} to={`/article/${article.id}`} className="group flex flex-col sm:flex-row gap-4 p-4 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer">
                  <div className="w-full sm:w-32 h-32 flex-shrink-0 rounded-lg overflow-hidden">
                    <img src={article.heroImageUrl} alt={article.title} title={article.title} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" loading="lazy" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <span className="text-xs text-accent-600 bg-accent-100 px-2 py-0.5 rounded-full font-medium">{categories.find((c) => c.slug === article.category)?.name || ''}</span>
                    <h3 className="mt-2 text-sm font-heading font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2">{article.title}</h3>
                    <p className="mt-1.5 text-xs text-foreground-500 line-clamp-2 leading-relaxed">{article.excerpt}</p>
                    <div className="mt-3 flex items-center gap-2 text-xs text-foreground-400">
                      <span>{article.author}</span><span>·</span><span>{article.date}</span><span>·</span><span>{article.readTime}</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        <section className="relative w-full py-16 md:py-24 overflow-hidden">
          <img src="https://readdy.ai/api/search-image?query=A%20wide%20expansive%20view%20of%20a%20beautifully%20manicured%20garden%20lawn%20with%20soft%20rolling%20hills%2C%20scattered%20ornamental%20trees%2C%20a%20distant%20elegant%20garden%20pavilion%2C%20warm%20morning%20light%2C%20peaceful%20pastoral%20landscape%2C%20professional%20nature%20photography&width=1600&height=600&seq=cta-bg-2026&orientation=landscape" alt="" className="absolute inset-0 w-full h-full object-cover object-top" loading="lazy" />
          <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-black/50"></div>
          <div className="relative z-10 w-full px-4 md:px-6 text-center">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-white mb-4">开始打造您的梦想庭院</h2>
            <p className="text-white/75 text-sm md:text-base max-w-xl mx-auto mb-8 leading-relaxed">无论您是正在规划新庭院，还是想要改造现有花园，我们都有丰富的设计方案和专业知识为您提供支持。</p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link to="/about" className="px-8 py-3 rounded-full bg-accent-500 text-white font-medium text-sm hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer">联系我们</Link>
              <Link to="/category/caoping-xuanzhong" className="px-8 py-3 rounded-full bg-white/15 backdrop-blur-sm text-white font-medium text-sm hover:bg-white/25 transition-colors border border-white/20 whitespace-nowrap cursor-pointer">草坪选种指南</Link>
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
          <div className="max-w-[800px] mx-auto">
            <div className="text-center mb-10">
              <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">常见问题</span>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">花园设计常见问题</h2>
              <p className="mt-2 text-foreground-500 text-sm">解答您关于庭院草坪与花园设计的疑惑</p>
            </div>
            <div className="space-y-3">
              {[
                { q: '如何选择适合自家庭院的草坪品种？', a: '选择草坪品种需要综合考虑气候、光照、土壤和使用需求。冷季型草如早熟禾、高羊茅适合北方地区，暖季型草如狗牙根、结缕草适合南方地区。阳光充足的庭院可选喜光品种，遮阴多的庭院则需选择耐阴品种，如细叶羊茅。' },
                { q: '草坪需要多久修剪一次？', a: '生长旺季（春、秋）建议每周修剪一次，夏季高温和冬季休眠期可适当减少频率。遵循"三分之一原则"：每次修剪量不超过草高的三分之一，修剪高度保持在5-7厘米为佳。' },
                { q: '人造草坪和天然草坪如何选择？', a: '天然草坪触感自然、生态环保，但需要定期修剪、浇水和施肥；人造草坪维护简单、四季常绿，但初期投入较高。有充足养护时间和庭院光照条件好的选天然草坪，追求低维护的选优质人造草坪。' },
                { q: '庭院花园设计的预算大概是多少？', a: '小型庭院（30㎡以下）基础设计加草坪铺设约5000-20000元；中型庭院（30-100㎡）整体景观设计约20000-80000元；大型庭院根据需求和风格定制，预算灵活。建议预留10%-15%的养护费用。' },
                { q: '新铺草坪多久可以踩踏？', a: '种子直播草坪一般需要8-12周根系稳定后方可轻度使用；草皮铺设草坪约4-6周可正常使用。首次踩踏前可用手指轻拉草叶测试：如果草叶不易拔起，说明根系已经稳固。' },
              ].map((faq, idx) => (
                <details key={idx} className="group rounded-xl bg-background-50 border border-background-200/70 overflow-hidden">
                  <summary className="px-5 md:px-6 py-4 cursor-pointer flex items-center justify-between gap-3 list-none">
                    <h4 className="text-sm md:text-base font-medium text-foreground-800 pr-8">{faq.q}</h4>
                    <i className="ri-add-line text-foreground-400 group-open:hidden flex-shrink-0"></i>
                    <i className="ri-subtract-line text-foreground-400 hidden group-open:block flex-shrink-0"></i>
                  </summary>
                  <div className="px-5 md:px-6 pb-4"><p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p></div>
                </details>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}